/**
 * Normalize a boolean/bit flag read from a database metadata row.
 *
 * Native driver paths (mssql / pg / mysql2 / oracledb / better-sqlite3) return
 * real booleans or numbers, but the MSSQL SQL Tools Service text path carries
 * every cell as a `displayValue` STRING — a set bit arrives as "1" (some STS
 * builds render `bit` as "True"/"False"), an unset one as "0"/"False". Reading
 * such a row with `value === true || value === 1` silently misclassifies every
 * set flag on the STS transport.
 *
 * Shared by the Electron metadata layer (`electron/metadataService.ts`) and the
 * renderer's object-definition service so both transports map identically.
 */
export function isFlagSet(value: unknown): boolean {
  if (value === true || value === 1) return true;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === '1' || normalized === 'true';
  }
  return false;
}
